module.exports = __webpack_public_path__ + "assets/28de2d0cdceab0f66a0da0179f6df679.png";